import React, { useEffect, useState } from 'react';
import { XIcon, GiftIcon, ZapIcon } from 'lucide-react';
const PURCHASE_URL = 'https://servicios-juridicos-2.myshopify.com/cart/51819904270567:1';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let shown = false;
    const show = () => {
      if (!shown) {
        shown = true;
        setIsVisible(true);
      }
    };
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      show();
    };
    // Push extra history entry so first Back press triggers popstate
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-id="element-317">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" data-id="element-318">
        {/* Top accent bar */}
        <div className="h-2 bg-gradient-to-r from-green-500 to-green-600 w-full" data-id="element-319" />

        {/* Close button */}
        <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors z-10" aria-label="Cerrar" data-id="element-320">
          <XIcon className="h-6 w-6" data-id="element-321" />
        </button>

        <div className="p-8" data-id="element-322">
          {/* Icon */}
          <div className="flex justify-center mb-4" data-id="element-323">
            <div className="bg-green-100 rounded-full p-4" data-id="element-324">
              <GiftIcon className="h-10 w-10 text-green-600" data-id="element-325" />
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-2xl md:text-3xl font-black text-gray-900 text-center mb-4 leading-tight uppercase" data-id="element-326">
            ¡Espera! No te vayas todavía 🚨
          </h2>

          {/* Body */}
          <p className="text-gray-700 text-center mb-3 text-base leading-relaxed" data-id="element-327">
            Si llegaste hasta acá, es porque{' '}
            <span className="font-bold text-gray-900" data-id="element-328">
              sentís la necesidad de mejorar y dar un salto real en tu carrera.
            </span>
          </p>
          <p className="text-gray-700 text-center mb-4 text-base leading-relaxed" data-id="element-329">
            Por eso, antes de que te vayas, queremos darte un{' '}
            <span className="font-bold text-green-600" data-id="element-330">
              descuento exclusivo del 15%
            </span>{' '}
            en el Megapack Jurídico 2026.
          </p>

          {/* Auto-apply notice */}
          <div className="bg-green-50 border border-green-300 rounded-xl p-4 mb-6 flex items-start gap-3" data-id="element-331">
            <ZapIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-332" />
            <p className="text-sm text-green-800 font-semibold text-left" data-id="element-333">
              Al presionar el botón, el descuento del 15% se aplica
              automáticamente en tu carrito. ¡Sin códigos ni pasos extra!
            </p>
          </div>

          {/* CTA Button */}
          <a href={PURCHASE_URL} onClick={() => setIsVisible(false)} className="block w-full bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-xl py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-center uppercase" data-id="element-334">
            🟩 Quiero Aprovechar el 15% OFF Ahora
          </a>

          {/* Dismiss link */}
          <button onClick={() => setIsVisible(false)} className="block w-full text-center text-sm text-gray-400 hover:text-gray-600 mt-4 transition-colors" data-id="element-335">
            No, prefiero pagar precio completo
          </button>
        </div>
      </div>
    </div>;
}